module.exports = __webpack_public_path__ + "Entypo.744ce600.ttf";